export default "__VITE_ASSET__9e075579__"